module.exports = __webpack_public_path__ + "static/media/Leave1.25de7178.png";